import { render, staticRenderFns } from "./SupplierAddressInfo.vue?vue&type=template&id=94160954&scoped=true&"
import script from "./SupplierAddressInfo.vue?vue&type=script&lang=js&"
export * from "./SupplierAddressInfo.vue?vue&type=script&lang=js&"
import style0 from "./SupplierAddressInfo.vue?vue&type=style&index=0&id=94160954&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94160954",
  null
  
)

export default component.exports